import React, {useState, useEffect, useRef} from 'react'
import { Image, Transformer } from 'react-konva';
import useImage from 'use-image';

const ImagenURL = (props) => {

    const {
        id, 
        x, 
        y, 
        urlImagen, 
        setImagenes,
        imagenes,
        tieneImagen, 
        lineas,
        isSelected,
        onSelect,
        onChange, 
        shapeProps,
        width,
        height,
        imgWidth,
        imgHeight,
        imgId
    } = props;

    const shapeRef = useRef();
    const trRef = useRef();

    useEffect(() => {
        if (isSelected) {
          // we need to attach transformer manually
          trRef.current.nodes([shapeRef.current]);
          trRef.current.getLayer().batchDraw();
        }
    }, [isSelected]);

    const [image, status] = useImage(urlImagen, 'anonymous');

    const handleDragStart = (e) =>{
        const id = e.target.attrs.id;
        setImagenes(
            imagenes.map((image)=>{
                return {
                    ...image,
                    isDragging: image.id === id,
                }
            })
        )
    }

    const handleDragEnd = (e) =>{
        const id = e.target.attrs.id;
        setImagenes(
            imagenes.map((image)=>{
                if(id === image.id){
                    return {
                        ...image,
                        isDragging: false,
                        x: e.target.attrs.x,
                        y: e.target.attrs.y
                    }
                }else{
                    return {
                        ...image,
                        isDragging: false,
                    }
                }
                
            }) 
        )

        lineas.map((line)=>{
            let listaPuntos = line.vertices;
            if(line.rectangulosLinea.includes(id)){
                if(line.rectangulosLinea[0]===id){
                    listaPuntos[0] = e.target.attrs.x+80;
                    listaPuntos[1] = e.target.attrs.y+35;
                }else{
                    listaPuntos[2] = e.target.attrs.x+80;
                    listaPuntos[3] = e.target.attrs.y+35;
                }
            }
        })
    }

    const handleTransform = (e) => {
        /* console.log('aca') */
        // transformer is changing scale of the node
        // and NOT its width or height
        // but in the store we have only width and height
        // to match the data better we will reset scale on transform end
        const node = shapeRef.current;
        const scaleX = node.scaleX();
        const scaleY = node.scaleY();

        // we will reset it back
        node.scaleX(1);
        node.scaleY(1);

        onChange({
          ...shapeProps,
          imgWidth: Math.max(2, node.width() * scaleX),
          imgHeight: Math.max(node.height() * scaleY),
          x: x,
          y: y,
          /* x: node.x(),
          y: node.y(), */
          // set minimal value
        });
    }

    
    
    return (
        <>  
            {tieneImagen ? (<Image
                id={imgId}
                x={x+width/2-imgWidth/2}
                y={y-imgHeight} 
                image={image}
                /* draggable */
                width={imgWidth}
                height={imgHeight}
                ref={shapeRef}
                
                onTransformEnd={handleTransform}

                /* onDblClick={handleClick} */
                onClick={onSelect}
                onTap={onSelect}
            />):(null)}
            
            {isSelected && (
                <Transformer
                    ref={trRef}
                    rotateEnabled={false}
                    boundBoxFunc={(oldBox, newBox) => {
                    // limit resize
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                        return newBox;
                    }}
                />
            )}
        </>
    )
}

export default ImagenURL;